import { resources } from "@constants/hardcoded-strings";
import { CardContainer } from "../common/card-container/card-container";
import { ContentPageBody } from "../common/content-page-body/content-page-body";
import { ContentPageHeader } from "../common/content-page-header/content-page-header";

export const HelpContainer = () => {
    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.help.header} />
            <ContentPageBody isMaxWidth={true}>
                <p>View Documentation: <a target={"_blank"} rel={"noreferrer"} href={"https://docs.iddataweb.com/docs"}>https://docs.iddataweb.com/docs</a></p>
            </ContentPageBody>
        </CardContainer>
    );
};